import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/auth'

let firebaseInstance
export function getFirebaseInstance (authConfig) {
  if (firebaseInstance) {
    return firebaseInstance
  }

  firebaseInstance = firebase.initializeApp({
    ...authConfig.firebase,
    projectId: authConfig.projectId
  })

  return firebaseInstance
}



// WEBPACK FOOTER //
// ./src/shared/db/firebase.js